$(document).ready(function(){
  $('.info-show-hide .info-item').click(function(){
    var $btn = $(this).find('.info-expcoll-btn');
    if(!$btn.hasClass('active')){
      $('.info-show-hide .info-item .info-expcoll-btn.active').parents('.info-item').find('.info-bottom').slideUp(300);
      $('.info-show-hide .info-item .info-expcoll-btn.active').removeClass('active');
      $btn.addClass('active');
      $(this).find('.info-bottom').slideDown(300);
    }
    else {
      $btn.removeClass('active');
      $(this).find('.info-bottom').slideUp(300);
    }
  });
});